export default "__VITE_ASSET__DTXxvP2Q__"